// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".yMoPM{font-weight:700;height:auto;line-height:1;padding:0 0 4rem}.yMoPM,.yMoPM:hover{text-decoration:underline}.yMoPM .btn__labelWrapper{padding:0}", ""]);
// Exports
exports.locals = {
	"addAnotherPersonBtn": "yMoPM"
};
module.exports = exports;
